import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedDirectivesModule } from '@directives/shared-directives.module';
import { SharedPipesModule } from '@pipes/shared-pipes.module';
import { SharedModule } from '../../shared/components/shared.module';
import { SpenModule } from '@classi/spen';
import { PortfolioGraduationComponent } from './student/portfolio-graduation/portfolio-graduation.component';
import { GraduationMessageDetailComponent } from './student/graduation-message-detail/graduation-message-detail.component';
import { LinkPrevNextComponent } from './student/link-prev-next/link-prev-next.component';

@NgModule({
  declarations: [PortfolioGraduationComponent, GraduationMessageDetailComponent, LinkPrevNextComponent],
  imports: [CommonModule, SharedModule, SharedDirectivesModule, RouterModule, SharedPipesModule, SpenModule],
  providers: [],
})
export class GraduationMessageStudentModule {}
